// src/services/adminAnalyticsCards.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminAnalyticsCards = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== "" && v !== null && v !== undefined
    )
  );

  const qs = new URLSearchParams(clean).toString();

  return adminApiRequest(
    `/admin/analytics-cards/cards${qs ? `?${qs}` : ""}`
  );
};

export const searchProductOverallSales = (query) => {
  const q = encodeURIComponent(query || "");

  return adminApiRequest(
    `/admin/analytics-cards/product-sales-search?q=${q}`
  );
};